import { EntityAction } from '../../types';
import { AssignmentAttemptActionType } from './types';

const defaultState = {
  assignmentAttempt: null,
  assignmentAttemptMessages: []
};

const attemptMessageReducer = (state = defaultState as any, action: EntityAction) => {
  switch (action.type) {
    case AssignmentAttemptActionType.GET_ASSIGNMENT_ATTEMPT_REQUEST_SUCCESS: {
      const { messages = [], ...assignmentAttempt } = action.data.assignmentAttempt;

      return {
        ...state,
        assignmentAttempt,
        assignmentAttemptMessages: messages
      };
    }
    case AssignmentAttemptActionType.CREATE_MESSAGE_REQUEST_SUCCESS: {
      const { message } = action.data;
      return {
        ...state,
        assignmentAttemptMessages: [...state.assignmentAttemptMessages, message]
      };
    }
    default:
      return state;
  }
};

export default attemptMessageReducer;
